import { IOrder } from '@aqx-core/common/api/order';

export interface IOrderHistoryDateRange {
  to: Date;
  from: Date;
  fromStart?: boolean;
}

export enum EOrderProfitStatus {
  ALL = 'ALL',
  PROFIT = 'PROFIT',
  LOSS = 'LOSS'
}

export enum EDeleteOrderType {
  ALL = 'ALL',
  LIMIT = 'LIMIT',
  STOP = 'STOP',
  STOP_LIMIT = 'STOP_LIMIT'
}

export interface IWebSocketOrBulkCloseRefreshOrdersParams {
  origin: 'SOCKET' | 'USER-ACTION';
  refreshOpenOrders?: boolean;
  refreshOrderHistory?: boolean;
}

export interface IOrderCurrentPrice {
  buy: number | undefined; // ask
  sell: number | undefined; // bid
}

export interface IUseLivePriceParams {
  symbol: IOrder['symbol'];
  isOpenPosition: boolean;
  orderType?: IOrder['orderType'];
  orderCurrentPrice?: IOrderCurrentPrice;
}

export type ITimeKeyFilterPosition = 'openTime' | 'closeTime';
